import { render } from "./TeamMember.vue?vue&type=template&id=640f8fec"
import script from "./TeamMember.vue?vue&type=script&lang=js"
export * from "./TeamMember.vue?vue&type=script&lang=js"

import "./TeamMember.vue?vue&type=style&index=0&id=640f8fec&lang=css"
script.render = render

export default script